import React from 'react';
import { useTranslation } from 'react-i18next';
import { Statistic, Grid } from 'semantic-ui-react';

const formatNumber = (num) => {
  if (!num) return '0';
  if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
  if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
  return num.toLocaleString();
};

const BillingSummaryCards = ({ summary }) => {
  const { t } = useTranslation();

  const totals = (summary || []).reduce(
    (acc, item) => ({
      tokens: acc.tokens + (item.total_tokens || 0),
      amount: acc.amount + (item.total_amount_cny || 0),
      calls: acc.calls + (item.total_call_count || 0),
    }),
    { tokens: 0, amount: 0, calls: 0 }
  );

  return (
    <Grid columns={3} stackable>
      <Grid.Column>
        <Statistic>
          <Statistic.Value>{formatNumber(totals.tokens)}</Statistic.Value>
          <Statistic.Label>
            {t('channel_billing.summary.total_tokens', '总 Token')}
          </Statistic.Label>
        </Statistic>
      </Grid.Column>
      <Grid.Column>
        <Statistic>
          <Statistic.Value>
            {totals.amount > 0 ? `¥${totals.amount.toFixed(2)}` : '-'}
          </Statistic.Value>
          <Statistic.Label>
            {t('channel_billing.summary.total_amount', '总金额 (CNY)')}
          </Statistic.Label>
        </Statistic>
      </Grid.Column>
      <Grid.Column>
        <Statistic>
          <Statistic.Value>{formatNumber(totals.calls)}</Statistic.Value>
          <Statistic.Label>
            {t('channel_billing.summary.total_calls', '总调用次数')}
          </Statistic.Label>
        </Statistic>
      </Grid.Column>
    </Grid>
  );
};

export default BillingSummaryCards;
